type FeatureFlags = {
  salesModule: boolean;
  manageModule: boolean;
  applicationCampaigns: boolean;
  onboardingRoadmapNotice: boolean;
  ticketMerchantOptions: boolean;
  equipment: boolean;
  equipmentForAgents: boolean;
};

export const FEATURES: FeatureFlags = {
  salesModule: false,
  manageModule: false,
  applicationCampaigns: false,
  onboardingRoadmapNotice: false,
  ticketMerchantOptions: false,
  equipment: false,
  equipmentForAgents: false,
};
